import React from 'react';
import { GiftIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <section className="w-full bg-white px-4 py-14" aria-labelledby="bonos" data-id="element-92" data-mp="1hifzdacqmyex">
      <div className="mx-auto w-full max-w-3xl" data-id="element-93" data-mp="1clfsix82drmr">
        <p className="text-center text-xs font-extrabold uppercase tracking-[0.25em] text-brandred" data-id="element-94" data-mp="18k4apdvfmap4">
          Bonos
        </p>
        <h2 id="bonos" className="mt-3 text-center font-display text-2xl font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-95" data-mp="258k5pphb9c9m">
          5 Bonos Exclusivos de la Dra. Karito
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[15px] leading-relaxed text-navy/70" data-id="element-96" data-mp="1w7c6943265dy">
          Cada bono elimina una de las situaciones que más tiempo, dudas y errores
          generan durante la consulta. El objetivo no es que estudies más: es que
          tengas la respuesta correcta cuando más la necesitas.
        </p>

        <div className="mt-8 space-y-4" data-id="element-97" data-mp="1etws968xc8gc">
          {bonuses.map(bonus => <article key={bonus.code} className="overflow-hidden rounded-3xl border border-navy/10 bg-cream" data-id="element-98" data-mp="1eru5qw6zcxgd">
              <div className="flex flex-col gap-4 p-5 sm:flex-row sm:items-center" data-id="element-99" data-mp="15rxceh9nbaez">
                {bonus.image ? <img src={bonus.image} alt={`Portada del bono ${bonus.title}`} className="mx-auto h-40 w-auto object-contain sm:mx-0 sm:h-36" data-id="element-100" data-mp="1aq8iqi0qf2sg" /> : <div className="mx-auto flex h-20 w-20 shrink-0 items-center justify-center rounded-2xl bg-navy sm:mx-0" data-id="element-101" data-mp="n2qz59rmfb0k">
                    <GiftIcon className="h-8 w-8 text-white" aria-hidden="true" data-id="element-102" data-mp="r5443vyjn4wa" />
                  </div>}
                <div className="flex-1 text-center sm:text-left" data-id="element-103" data-mp="d4tawm9rhe7y">
                  <span className="inline-block rounded-full bg-brandred px-3 py-1 text-[11px] font-extrabold uppercase tracking-widest text-white" data-id="element-104" data-mp="i3ntpo7qb2s2">
                    Bono {bonus.code.replace('B', '')}
                  </span>
                  <h3 className="mt-2 text-lg font-extrabold leading-tight text-navy" data-id="element-105" data-mp="2f0ac3jzaldok">
                    {bonus.title}
                  </h3>
                  <p className="mt-2 text-[15px] leading-snug text-navy/70" data-id="element-106" data-mp="2615a23oiv27n">
                    {bonus.text}
                  </p>
                  <p className="mt-3 text-sm font-bold text-navy/50" data-id="element-107" data-mp="32qeczjl3izbv">
                    Valor:{' '}
                    <span className="text-brandred line-through decoration-brandred/50" data-id="element-108" data-mp="2yqvu0tcu4ybo">
                      {bonus.price}
                    </span>{' '}
                    · Hoy gratis
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <div className="mt-8 rounded-3xl bg-navy px-5 py-6 text-center" data-id="element-109" data-mp="1icm2jqdaqtgm">
          <p className="text-sm font-semibold uppercase tracking-widest text-white/60" data-id="element-110" data-mp="1dbyfffs6uwro">
            Valor total de los bonos
          </p>
          <p className="mt-1 font-display text-4xl font-extrabold text-white" data-id="element-111" data-mp="13a47in5ihx6m">
            $150 USD
          </p>
          <p className="mt-2 text-[15px] font-semibold text-brandred" data-id="element-112" data-mp="187xaz8ffkd37">
            Hoy los recibes sin costo adicional
          </p>
        </div>

        <div className="mt-8" data-id="element-113" data-mp="1hxz1e6v9a7la">
          <CTAButton label="Quiero los 5 bonos gratis" data-id="element-114" data-mp="1hy8rrvk7qgri" />
        </div>
      </div>
    </section>;
}